"use client";

import { useAuth } from "@klarify/auth/client";
import { useEffect } from "react";
import { getRecordingWorker } from "./global";

export function RecordingWorkerComponent() {
	// `isSignedIn` is undefined until Clerk loads; the effect keys on it so
	// the warm-up runs on the transition to true.
	const { isSignedIn } = useAuth();

	// Warm-up only: getManager() self-boots the worker, so correctness never
	// depends on this mount. The sign-in gate keeps anonymous visitors on the
	// (app) auth routes from downloading and spawning the worker.
	useEffect(() => {
		if (isSignedIn) {
			getRecordingWorker();
		}
	}, [isSignedIn]);

	// S3 URL/upload initialization is handled inside recording/streams.ts.
	return null;
}
